import { c as _c } from "react/compiler-runtime";
import { TableCell, TableHead, TableRow } from "@/components/ui/table";
import { isEntryOfContentType } from "@/lib/contentful/guards";
import { cn } from "@/lib/utils";
import type { ColumnHeaderEntry, RowEntry, ValueEntry } from "./ComparisonTable";
interface Props {
  row: RowEntry;
  columnOrder: string[];
}
export default function ComparisonTableRow(t0) {
  const $ = _c(13);
  const {
    row,
    columnOrder
  } = t0;
  let t1;
  if ($[0] !== columnOrder || $[1] !== row.fields.description || $[2] !== row.fields.heading || $[3] !== row.fields.values || $[4] !== row.sys.id) {
    const values = row.fields.values.filter(_temp);
    let t2;
    if ($[6] !== row.fields.heading) {
      t2 = <strong className="text-sm font-medium">{row.fields.heading}</strong>;
      $[6] = row.fields.heading;
      $[7] = t2;
    } else {
      t2 = $[7];
    }
    let t3;
    if ($[8] !== row.fields.description) {
      t3 = row.fields.description && <small className="text-xs font-normal">{row.fields.description}</small>;
      $[8] = row.fields.description;
      $[9] = t3;
    } else {
      t3 = $[9];
    }
    let t4;
    if ($[10] !== t2 || $[11] !== t3) {
      t4 = <TableHead scope="row" className="h-auto p-4 align-top flex flex-col whitespace-normal">{t2}{t3}</TableHead>;
      $[10] = t2;
      $[11] = t3;
      $[12] = t4;
    } else {
      t4 = $[12];
    }
    t1 = <TableRow key={row.sys.id} className="border-b border-[color:var(--border)]">{t4}{columnOrder.map(columnId => {
        const matchingValue = values.find(value_0 => value_0.fields.column.sys.id === columnId);
        const resolvedColumn = isEntryOfContentType(matchingValue?.fields.column, "comparisonTableColumnHeader") ? matchingValue.fields.column : null;
        const isEmphasized = resolvedColumn?.fields.emphasize === true;
        return <TableCell key={`${row.sys.id}-${columnId}`} className={cn("p-4 align-top text-sm font-medium", isEmphasized ? "bg-(--muted)" : "text-muted-foreground")}>{matchingValue?.fields.value ?? ""}</TableCell>;
      })}</TableRow>;
    $[0] = columnOrder;
    $[1] = row.fields.description;
    $[2] = row.fields.heading;
    $[3] = row.fields.values;
    $[4] = row.sys.id;
    $[5] = t1;
  } else {
    t1 = $[5];
  }
  return t1;
}
function _temp(value) {
  return isEntryOfContentType(value, "comparisonTableValue");
}